export default function computeRevenueForSeller(subOrderPrice = 0) {
	return Math.floor(subOrderPrice - subOrderPrice * (1.5 / 100) - 1);
}
